module.exports = __webpack_public_path__ + "static/media/contempSpace.5ff2ef25.jpg";